import React from "react";
import { Building2 } from "lucide-react";
import { KnowledgeManager } from "@/components/KnowledgeManager";

const COMPANY_NAME = "ABC Services";

export default function AboutCompany() {
  return (
    <div data-testid="about-company-page">
      <div className="mb-6">
        <h1 className="flex items-center gap-2 font-display text-3xl font-semibold text-white sm:text-4xl">
          <Building2 className="text-[#00E5FF]" size={30} /> About {COMPANY_NAME}
        </h1>
        <p className="mt-1 text-sm text-slate-400">Upload documents, PDFs and website links about your business. Every associate reads and remembers this so the whole team understands {COMPANY_NAME}.</p>
      </div>

      <div className="max-w-3xl rounded-2xl border border-white/8 bg-[#050D1C]/40 p-5">
        <div className="mb-4">
          <div className="font-display text-lg font-semibold text-white">Company knowledge base</div>
          <div className="text-xs text-slate-400">Shared with all associates</div>
        </div>
        <KnowledgeManager scope="company" />
      </div>
    </div>
  );
}
